<template>
    <div>
        <b-card class="text-center" border-variant="light"  align="left">
            <b-form>
            <b-form-group
                id="name"
                label="Name:"
                label-for="name"
                label-cols-lg="3"
                label-size="sm"
            >
                <b-form-input
                    id="name"
                    type="text"
                    required
                    placeholder="Enter Name"
                    autocomplete="off"
                    size="sm"
                    v-model="form.name"
                ></b-form-input>
            </b-form-group>


            <b-form-group
                id="description"
                label="Description:"
                label-for="Description"
                label-cols-lg="3"
                label-size="sm"
            >
                <b-form-input
                    id="Description"
                    type="text"
                    reqtyped
                    placeholder="Enter Description"
                    autocomplete="off"
                    size="sm"
                    v-model="form.description"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="type"
                label="Network Type:"
                label-for="type"
                label-cols-lg="3"
                label-size="sm"
            >
                <b-form-input
                    id="type"
                    type="text"
                    required
                    placeholder="Enter Network Type"
                    autocomplete="off"
                    size="sm"
                    v-model="form.network_type"
                ></b-form-input>
            </b-form-group>


            <b-form-group
                id="organisation"
                label="Organisation:"
                label-for="organisation"
                label-cols-lg="3"
                label-size="sm"
            >
                <b-form-input
                    id="organisation"
                    type="text"
                    required
                    placeholder="Enter Organisation"
                    autocomplete="off"
                    size="sm"
                    v-model="form.organisation"
                ></b-form-input>
            </b-form-group>


            <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:32px; font-size:15px; valign:center">
                <div style="line-height:5px">{{lastError}}</div>                        
            </b-alert>

            <b-alert v-if="action ==='deleteNW'" show variant="warning" align="center" class="m-2" style="height:32px; font-size:15px; valign:center">
                <div style="line-height:5px">This action is irreversible!</div>                        
            </b-alert>

            <b-row align-h="end">
                <b-col style="text-align:right">
                    <b-button v-on:click='cancel' variant="info" size="sm" class="mr-1">Cancel</b-button>
                    <b-button v-if="action ==='deleteNW'" v-on:click='save' variant="info" size="sm">Delete</b-button>
                    <b-button v-else v-on:click='save' variant="info" size="sm">Save</b-button>
                </b-col>    
            </b-row>

            </b-form>

        </b-card>

    </div>

</template>

<script>
import IPManService from '@/api-services/ipman.service'

export default {
    name: 'IpmanNetwork',
    data() {
        return {
            lastError: '',
            form: {
                name: '',
                network_type: '',
                organisation: '',
                description: '',
            },
        }
    },
    props: {
        network: Object,
        action: String,
    },
    mounted(){
        if (this.network){
            this.form.name=this.network.name.S
            this.form.network_type=this.network.network_type.S
            this.form.organisation=this.network.organisation.S
            this.form.description=this.network.description.S
        } else {
            this.form.name=''
            this.form.network_type=''
            this.form.organisation=''
            this.form.description=''
        }
    },
    methods: {
        save() {
            //if this.network is set then this is an edit
            if (this.action=="editNW"){
                let promise = IPManService.updateNetwork(this.network.guid.S, this.form)
                return promise.then((data) => {
                    this.$emit('complete')
                }).catch(error => {
                    console.log(error.response.data.error)
                    this.lastError=error.response.data.error
                })        
            } else if (this.action=="createNW") { //is an add  new network
                let promise = IPManService.createNetwork(this.form)
                return promise.then((data) => {
                    console.log(data)
                    this.$emit('complete')
                }).catch(error => {
                    this.lastError=error.response.data.error
                })        
            } else if (this.action=="deleteNW") { //is a delete network
                let promise = IPManService.deleteNetwork(this.network.guid.S)
                return promise.then((data) => {
                    console.log(data)
                    this.$emit('complete')
                }).catch(error => {
                    this.lastError=error.response.data.error
                })        
            }
        },
        cancel() {
            //close the modal.
            this.$emit('cancelled')
        },
    }
}
</script>
